import styled from 'styled-components';

export const PriceSoldOutWrapper = styled.div(
  props => `
    width: 16.8rem;
    display: flex;
    border-left: 0.7px solid ${props.theme.colors.red.lightff};
    background-color: ${props.theme.colors.red.bgRedDark};
    border-radius: 0 1rem 1rem 0;
    flex-direction: column;
    justify-content: flex-end;
`);

export const PriceSoldOutInnerWrapper = styled.div(
  props => `
    width:100%;
    display: flex;
    padding: ${props.spelSprice ? '1.5rem 1.5rem 0 1.5rem' : '1.5rem'} ;
    height: ${props.spelSprice ? '18rem' : '100%'};
    flex-direction: column;
    justify-content: flex-end;
    align-items: flex-end;
  `,
);




export const SoldOutMainText = styled.p(
  props => `
    font-size: ${props.theme.font.large.font18};
    color: ${props.theme.colors.red.base};
    font-weight: ${props.theme.font.fontWeight.black}  
  `
);

export const MissedText = styled.p(
  props => `
    font-size: ${props.theme.font.base};
    color: ${props.theme.colors.grey.base}
  `
);

export const PropertyBookedText = styled.p(
  props => `
    font-size: ${props.theme.font.base};
    color: ${props.theme.colors.grey.base};
    padding-top: ${props.theme.spacing.base};
    text-align: ${props.theme.font.textAlign.right};
  `
);
